import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import QualificationsCrud from "./QualificationsCrud";
import ManageProfilePicture from "./ManageProfilePicture";

export default function CounsellorProfile({ profile, user, value }) {
  const [isEditing, setIsEditing] = useState(false);

  console.log(profile)
  const [isLoading, setIsLoading] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [qualifcations, setQualifications] = useState([]);

  const [savedSnapshot, setSavedSnapshot] = useState(null);

  const [therapySearch, setTherapySearch] = useState("");
  const [supportSearch, setSupportSearch] = useState("");

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${ApiConnectionString}/api/qualifications`, {
        headers: { Authorization: `bearer ${user.token}` },
      });

      if (res.status == 200) {
        setQualifications(res.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const [form, setForm] = useState({
    showPhone: false,
    showEmail: true,

    displayName: "",
    headLine: "",
    aboutMe: "",
    howIWork: "",

    email: "",
    contactNumber: "",

    websiteUrl: "",
    noWebsite: false,

    online: false,
    phone: false,

    offersInPerson: false,
    postcode: "",
    townCity: "",

    platforms: "",

    sessionLength: 0,
    pricePerSession: 0,

    neurodivergentInformed: false,
    neurodivergentSpecialist: false,
    adhdInformed: false,
    adhdSpecialist: false,

    worksWithAdults: false,
    worksWithChildren: false,
    worksWithAdolescents: false,

    cbt: false,
    act: false,
    dbt: false,
    psychodynamic: false,
    personCentred: false,
    integrative: false,
    solutionFocused: false,
    traumaInformed: false,
    adhdCoaching: false,
    autismAffirming: false,
    neurodiversityAffirming: false,
    talkingTherapy: false,
    psychosexual: false,
    adhd: false,
    autism: false,
    anxiety: false,
    burnout: false,
    emotionalRegulation: false,
    maskingAndPeoplePleasing: false,
    selfEsteemAndIdentity: false,
    relationshipsAndCommunication: false,
    workplaceStressAndAdjustments: false,
    traumaInformedSupport: false,
    lateDiagnosisSupport: false,
    sensoryProcessing: false,
  });

  useEffect(() => {
    fetchData();

    const next = {
      showPhone: !!profile?.showPhone,
      showEmail: profile?.showEmail === undefined ? true : !!profile?.showEmail,

      displayName: profile?.displayName || "",
      headLine: profile?.headLine || "",
      aboutMe: profile?.aboutMe || "",
      howIWork: profile?.howIWork || "",

      email: profile?.email || "",
      contactNumber: profile?.contactNumber || "",

      websiteUrl: profile?.websiteUrl || "",
      noWebsite: !profile?.websiteUrl,

      online: !!profile?.online,
      phone: !!profile?.phone,

      offersInPerson: !!profile?.offersInPerson,
      postcode: profile?.postcode || "",
      townCity: profile?.townCity || "",

      platforms: profile?.platforms || "",

      sessionLength: profile?.sessionLength ?? 0,
      pricePerSession: profile?.pricePerSession ?? 0,

      neurodivergentInformed: !!profile?.neurodivergentInformed,
      neurodivergentSpecialist: !!profile?.neurodivergentSpecialist,
      adhdInformed: !!profile?.adhdInformed,
      adhdSpecialist: !!profile?.adhdSpecialist,

      worksWithAdults: !!profile?.worksWithAdults,
      worksWithChildren: !!profile?.worksWithChildren,
      worksWithAdolescents: !!profile?.worksWithAdolescents,

      cbt: !!profile?.cbt,
      act: !!profile?.act,
      dbt: !!profile?.dbt,
      psychodynamic: !!profile?.psychodynamic,
      personCentred: !!profile?.personCentred,
      integrative: !!profile?.integrative,
      solutionFocused: !!profile?.solutionFocused,
      traumaInformed: !!profile?.traumaInformed,
      adhdCoaching: !!profile?.adhdCoaching,
      autismAffirming: !!profile?.autismAffirming,
      neurodiversityAffirming: !!profile?.neurodiversityAffirming,
      talkingTherapy: !!profile?.talkingTherapy,
      psychosexual: !!profile?.psychosexual,
      adhd: !!profile?.adhd,
      autism: !!profile?.autism,
      anxiety: !!profile?.anxiety,
      burnout: !!profile?.burnout,
      emotionalRegulation: !!profile?.emotionalRegulation,
      maskingAndPeoplePleasing: !!profile?.maskingAndPeoplePleasing,
      selfEsteemAndIdentity: !!profile?.selfEsteemAndIdentity,
      relationshipsAndCommunication: !!profile?.relationshipsAndCommunication,
      workplaceStressAndAdjustments: !!profile?.workplaceStressAndAdjustments,
      traumaInformedSupport: !!profile?.traumaInformedSupport,
      lateDiagnosisSupport: !!profile?.lateDiagnosisSupport,
      sensoryProcessing: !!profile?.sensoryProcessing,
    };

    setForm(next);
    setSavedSnapshot(next);
    setIsEditing(false);
    setTherapySearch("");
    setSupportSearch("");
  }, [profile]);

  const currencySymbol =
    (value?.country || profile?.country) === "UK" ? "£" : "$";

  const display = (v) => {
    if (v === null || v === undefined) return "—";
    if (typeof v === "string" && v.trim() === "") return "—";
    return v;
  };

  const toNumberOrZero = (v) => {
    if (v === "" || v === null || v === undefined) return 0;
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const onText = (e) => {
    const { name, value: v } = e.target;
    setForm((prev) => ({ ...prev, [name]: v }));
    setSaveError("");
  };

  const onToggle = (e) => {
    const { name, checked } = e.target;
    setSaveError("");

    setForm((prev) => {
      if (name === "noWebsite") {
        return {
          ...prev,
          noWebsite: checked,
          websiteUrl: checked ? "" : prev.websiteUrl,
        };
      }

      if (name === "adhdInformed" && checked)
        return { ...prev, adhdInformed: true, adhdSpecialist: false };
      if (name === "adhdSpecialist" && checked)
        return { ...prev, adhdSpecialist: true, adhdInformed: false };

      if (name === "neurodivergentInformed" && checked) {
        return {
          ...prev,
          neurodivergentInformed: true,
          neurodivergentSpecialist: false,
        };
      }
      if (name === "neurodivergentSpecialist" && checked) {
        return {
          ...prev,
          neurodivergentSpecialist: true,
          neurodivergentInformed: false,
        };
      }

      return { ...prev, [name]: checked };
    });
  };

  const buildPayload = () => {
    const base = { ...(profile || {}) };

    return {
      ...base,

      showPhone: !!form.showPhone,
      showEmail: !!form.showEmail,

      neurodivergentInformed: !!form.neurodivergentInformed,
      neurodivergentSpecialist: !!form.neurodivergentSpecialist,
      adhdInformed: !!form.adhdInformed,
      adhdSpecialist: !!form.adhdSpecialist,

      displayName: form.displayName || "",
      headLine: form.headLine || "",
      aboutMe: form.aboutMe || "",
      howIWork: form.howIWork || "",

      email: form.email || "",
      websiteUrl: form.noWebsite ? "" : form.websiteUrl || "",
      contactNumber: form.contactNumber || "",

      online: !!form.online,
      phone: !!form.phone,

      offersInPerson: !!form.offersInPerson,
      postcode: form.postcode || "",
      townCity: form.townCity || "",

      platforms: form.platforms || "",

      worksWithAdults: !!form.worksWithAdults,
      worksWithChildren: !!form.worksWithChildren,
      worksWithAdolescents: !!form.worksWithAdolescents,

      cbt: !!form.cbt,
      act: !!form.act,
      dbt: !!form.dbt,
      psychodynamic: !!form.psychodynamic,
      personCentred: !!form.personCentred,
      integrative: !!form.integrative,
      solutionFocused: !!form.solutionFocused,
      traumaInformed: !!form.traumaInformed,
      adhdCoaching: !!form.adhdCoaching,
      autismAffirming: !!form.autismAffirming,
      neurodiversityAffirming: !!form.neurodiversityAffirming,
      talkingTherapy: !!form.talkingTherapy,
      psychosexual: !!form.psychosexual,
      adhd: !!form.adhd,
      autism: !!form.autism,
      anxiety: !!form.anxiety,
      burnout: !!form.burnout,
      emotionalRegulation: !!form.emotionalRegulation,
      maskingAndPeoplePleasing: !!form.maskingAndPeoplePleasing,
      selfEsteemAndIdentity: !!form.selfEsteemAndIdentity,
      relationshipsAndCommunication: !!form.relationshipsAndCommunication,
      workplaceStressAndAdjustments: !!form.workplaceStressAndAdjustments,
      traumaInformedSupport: !!form.traumaInformedSupport,
      lateDiagnosisSupport: !!form.lateDiagnosisSupport,
      sensoryProcessing: !!form.sensoryProcessing,

      sessionLength: toNumberOrZero(form.sessionLength),
      pricePerSession: toNumberOrZero(form.pricePerSession),
    };
  };

  const handleCancel = () => {
    setIsEditing(false);
    setTherapySearch("");
    setSupportSearch("");
    if (savedSnapshot) setForm(savedSnapshot);
  };

  const handleSave = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setIsLoading(true);
    setSaveError("");

    try {
      const payload = buildPayload();

      await axios.put(`${ApiConnectionString}/api/counsellorProfile`, payload, {
        headers: { Authorization: `bearer ${user.token}` },
      });

      setSavedSnapshot(form);
      setIsEditing(false);
      setTherapySearch("");
      setSupportSearch("");
    } catch (error) {
      setSaveError(
        error?.response?.data || "Something went wrong. Please try again.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const isDirty = useMemo(() => {
    if (!savedSnapshot) return false;
    return JSON.stringify(form) !== JSON.stringify(savedSnapshot);
  }, [form, savedSnapshot]);

  const formatsText = () => {
    const out = [];
    if (form.online) out.push("Online");
    if (form.phone) out.push("Phone");
    if (form.offersInPerson) out.push("In person");
    return out.length ? out.join(", ") : "—";
  };

  const privacyText = (v) => (v ? "Visible on profile" : "Hidden on profile");

  const focusItems = useMemo(
    () => [
      { name: "neurodivergentInformed", label: "Neurodivergent affirming" },
      { name: "neurodivergentSpecialist", label: "Neurodivergent specialist" },
      { name: "adhdInformed", label: "ADHD affirming" },
      { name: "adhdSpecialist", label: "ADHD specialist" },
    ],
    [],
  );

  const worksWithItems = useMemo(
    () => [
      { name: "worksWithAdults", label: "Adults" },
      { name: "worksWithAdolescents", label: "Adolescents" },
      { name: "worksWithChildren", label: "Children" },
    ],
    [],
  );

  const therapyItems = useMemo(
    () => [
      { name: "cbt", label: "CBT" },
      { name: "act", label: "ACT" },
      { name: "dbt", label: "DBT" },
      { name: "psychodynamic", label: "Psychodynamic" },
      { name: "personCentred", label: "Person centred" },
      { name: "integrative", label: "Integrative" },
      { name: "solutionFocused", label: "Solution focused" },
      { name: "traumaInformed", label: "Trauma informed" },
      { name: "adhdCoaching", label: "ADHD coaching" },
      { name: "autismAffirming", label: "Autism affirming" },
      { name: "neurodiversityAffirming", label: "Neurodiversity affirming" },
      { name: "talkingTherapy", label: "Talking therapy" },
      { name: "psychosexual", label: "Psychosexual" },
    ],
    [],
  );

  const supportItems = useMemo(
    () => [
      { name: "adhd", label: "ADHD" },
      { name: "autism", label: "Autism" },
      { name: "anxiety", label: "Anxiety" },
      { name: "burnout", label: "Burnout" },
      { name: "emotionalRegulation", label: "Emotional regulation" },
      {
        name: "maskingAndPeoplePleasing",
        label: "Masking and people pleasing",
      },
      { name: "selfEsteemAndIdentity", label: "Self esteem and identity" },
      {
        name: "relationshipsAndCommunication",
        label: "Relationships and communication",
      },
      {
        name: "workplaceStressAndAdjustments",
        label: "Workplace stress and adjustments",
      },
      { name: "traumaInformedSupport", label: "Trauma informed support" },
      { name: "lateDiagnosisSupport", label: "Late diagnosis support" },
      { name: "sensoryProcessing", label: "Sensory processing" },
    ],
    [],
  );

  const selectedText = (items) =>
    items
      .filter((it) => !!form[it.name])
      .map((it) => it.label)
      .join(", ") || "—";

  const chipList = (items) => {
    const selected = items.filter((it) => !!form[it.name]);
    if (!selected.length) return <div className="bcs-subtitle">—</div>;

    return (
      <div className="d-flex flex-wrap gap-2">
        {selected.map((it) => (
          <span
            key={it.name}
            className="badge rounded-pill text-bg-light border"
          >
            {it.label}
          </span>
        ))}
      </div>
    );
  };

  const chipEditor = (items, searchValue, setSearchValue, helpText) => {
    const q = (searchValue || "").trim().toLowerCase();
    const list = !q
      ? items
      : items.filter((it) => it.label.toLowerCase().includes(q));

    return (
      <>
        <input
          className="form-control bcs-brand-input mb-2"
          type="text"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          placeholder="Search"
        />

        {isEditing && helpText ? (
          <div className="bcs-subtitle mb-2">{helpText}</div>
        ) : null}

        <div className="d-flex flex-wrap gap-2">
          {list.map((it) => (
            <label
              key={it.name}
              className={`btn btn-sm ${form[it.name] ? "brand-purple-inline" : "brand-purple-outline"}`}
              style={undefined}
            >
              <input
                type="checkbox"
                name={it.name}
                checked={!!form[it.name]}
                onChange={onToggle}
                className="d-none"
              />
              {it.label}
            </label>
          ))}
        </div>
      </>
    );
  };
  return (
    <div className="bcs-account-page p-3 p-md-4">
      {isEditing ? (
        <div className="lp-nav">
          <div className="lp-wrap">
            <div className="text-start">
              <div className="brand-dark-purple">Editing profile</div>
              <div className="bcs-subtitle">
                {isDirty
                  ? "Unsaved changes, remember to save before leaving."
                  : "No changes yet."}
              </div>
            </div>

            <div className="d-flex align-items-center gap-2">
              <button
                type="button"
                className="lp-btn lp-btn-ghost"
                onClick={handleCancel}
                disabled={isLoading}
              >
                Discard changes
              </button>

              <button
                type="button"
                className="lp-btn brand-purple-inline"
                onClick={handleSave}
                disabled={isLoading || !isDirty}
              >
                {isLoading ? "Saving..." : "Save changes"}
              </button>
            </div>
          </div>
        </div>
      ) : null}

      <div className="bcs-account-card bg-white p-3 p-md-4">
        <div className="d-flex flex-wrap align-items-start gap-3 mb-3">
          <div className="text-start">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <h1 className="m-0 brand-dark-purple" style={undefined}>
                Your profile
              </h1>
            </div>
            {isEditing ? (
              <div className="bcs-subtitle mt-1">
                Keep your details up to date so people know what you offer and
                how to contact you.
              </div>
            ) : (
              <div className="bcs-subtitle mt-1">
                Keep details up to date so clients can book with confidence.
              </div>
            )}
          </div>

          <div className="d-flex align-items-center gap-2 ms-auto">
      {profile?.profileVisable ? (
  <button
    type="button"
    className="lp-btn lp-btn-ghost"
    disabled={isEditing}
    onClick={() =>
      window.open(
        `https://neurotherapydirectory.com/therapist/${profile.slug}`,
        "_blank"
      )
    }
  >
    View public page
  </button>
) : null}

            {!isEditing ? (
              <button
                type="button"
                className="lp-btn brand-purple-inline"
                onClick={() => setIsEditing(true)}
              >
                Edit profile
              </button>
            ) : null}
          </div>
        </div>

        <div className="bcs-divider mb-3" />

        <div className="d-flex flex-wrap gap-2 mb-3">
          <span className="badge rounded-pill text-bg-light border">
            Session length{" "}
            {display(form.sessionLength) === "—"
              ? "—"
              : `${form.sessionLength} mins`}
          </span>
          <span className="badge rounded-pill text-bg-light border">
            Price{" "}
            {display(form.pricePerSession) === "—"
              ? "—"
              : `${currencySymbol}${form.pricePerSession}`}
          </span>
          <span className="badge rounded-pill text-bg-light border">
            Formats {formatsText()}
          </span>
        </div>

        <form onSubmit={handleSave}>
          <div className="mb-4">
            <div className="text-start">
              <div className="brand-dark-purple mb-2">Profile basics</div>
            </div>

            <ManageProfilePicture
              profile={profile}
              user={user}
              isEditing={isEditing}
            />
            {isEditing ? (
              <div className="bcs-subtitle mb-2">
                These are the first things people see, keep them clear and
                friendly.
              </div>
            ) : null}

            <div className="row g-3">
              <div className="col-12">
                <label className="form-label bcs-subtitle m-0">
                  Display name
                </label>
                {isEditing ? (
                  <>
                    <div className="bcs-subtitle">
                      Use your name or the name you want clients to see.
                    </div>
                    <input
                      className="form-control bcs-brand-input"
                      name="displayName"
                      type="text"
                      value={form.displayName}
                      onChange={onText}
                      placeholder="eg Jordan Smith"
                    />
                  </>
                ) : (
                  <input
                    className="form-control bcs-brand-input mt-2"
                    type="text"
                    value={
                      display(form.displayName) === "—" ? "" : form.displayName
                    }
                    readOnly
                    disabled
                  />
                )}
              </div>

              <div className="col-12">
                <label className="form-label bcs-subtitle m-0">Headline</label>
                {isEditing ? (
                  <>
                    <div className="bcs-subtitle">
                      A short one line summary of what you offer.
                    </div>
                    <input
                      className="form-control bcs-brand-input"
                      name="headLine"
                      type="text"
                      value={form.headLine}
                      onChange={onText}
                      placeholder="eg Neurodivergent affirming counsellor for anxiety and burnout"
                    />
                  </>
                ) : (
                  <input
                    className="form-control bcs-brand-input mt-2"
                    type="text"
                    value={display(form.headLine) === "—" ? "" : form.headLine}
                    readOnly
                    disabled
                  />
                )}
              </div>
            </div>
          </div>

          <div className="mb-4">
            <div className="text-start">
              <div className="brand-dark-purple mb-2">About and approach</div>
            </div>
            {isEditing ? (
              <div className="bcs-subtitle mb-2">
                This helps people decide if you feel like a good fit. Write in
                plain language.
              </div>
            ) : null}

            <div className="mb-3">
              <label className="form-label bcs-subtitle m-0">About me</label>
              {isEditing ? (
                <div className="bcs-subtitle">
                  Share who you are, who you support, and what a client can
                  expect.
                </div>
              ) : null}
              {isEditing ? (
                <textarea
                  className="form-control bcs-brand-input"
                  name="aboutMe"
                  value={form.aboutMe}
                  onChange={onText}
                  rows={5}
                  placeholder="A few sentences about your background and the people you support..."
                />
              ) : (
                <textarea
                  className="form-control bcs-brand-input mt-2"
                  value={display(form.aboutMe) === "—" ? "" : form.aboutMe}
                  readOnly
                  disabled
                  rows={5}
                />
              )}
            </div>

            <div>
              <label className="form-label bcs-subtitle m-0">How I work</label>
              {isEditing ? (
                <div className="bcs-subtitle">
                  Describe your approach, structure of sessions, and how you
                  work towards goals.
                </div>
              ) : null}
              {isEditing ? (
                <textarea
                  className="form-control bcs-brand-input"
                  name="howIWork"
                  value={form.howIWork}
                  onChange={onText}
                  rows={5}
                  placeholder="What sessions look like, what you focus on, and how you support progress..."
                />
              ) : (
                <textarea
                  className="form-control bcs-brand-input mt-2"
                  value={display(form.howIWork) === "—" ? "" : form.howIWork}
                  readOnly
                  disabled
                  rows={5}
                />
              )}
            </div>
          </div>

          <div className="mb-4">
            <div className="text-start">
              <div className="brand-dark-purple mb-2">Contact and privacy</div>
            </div>
            {isEditing ? (
              <div className="bcs-subtitle mb-2">
                Add the details you want enquiries to go to. You can choose what
                shows publicly.
              </div>
            ) : null}

            <div className="row g-3 mb-3">
              <div className="col-12">
                <label className="form-label bcs-subtitle m-0">
                  Contact number
                </label>
                {isEditing ? (
                  <div className="bcs-subtitle">
                    Optional, add this if you are happy to be contacted by
                    phone.
                  </div>
                ) : null}
                {isEditing ? (
                  <input
                    className="form-control bcs-brand-input"
                    name="contactNumber"
                    type="text"
                    value={form.contactNumber}
                    onChange={onText}
                    placeholder="eg 07123 456789"
                  />
                ) : (
                  <input
                    className="form-control bcs-brand-input mt-2"
                    type="text"
                    value={
                      display(form.contactNumber) === "—"
                        ? ""
                        : form.contactNumber
                    }
                    readOnly
                    disabled
                  />
                )}
              </div>

              <div className="col-12">
                <label className="form-label bcs-subtitle m-0">
                  Contact email
                </label>
                {isEditing ? (
                  <div className="bcs-subtitle">
                    This is where enquiries will be sent.
                  </div>
                ) : null}
                {isEditing ? (
                  <input
                    className="form-control bcs-brand-input"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={onText}
                    placeholder="eg hello@yourpractice.com"
                  />
                ) : (
                  <input
                    className="form-control bcs-brand-input mt-2"
                    type="email"
                    value={display(form.email) === "—" ? "" : form.email}
                    readOnly
                    disabled
                  />
                )}
              </div>
            </div>

            <div className="row g-3 mb-3">
              <div className="col-12">
                <div className="d-flex align-items-center gap-2">
                  <div className="text-start">
                    <div className="brand-dark-purple">Show phone</div>
                    {isEditing ? (
                      <div className="bcs-subtitle">
                        If on, your phone number appears on your public profile.
                      </div>
                    ) : (
                      <div className="bcs-subtitle">
                        {privacyText(!!form.showPhone)}
                      </div>
                    )}
                  </div>

                  <input
                    className="form-check-input bcs-brand-check m-0"
                    type="checkbox"
                    name="showPhone"
                    checked={!!form.showPhone}
                    onChange={isEditing ? onToggle : undefined}
                    readOnly={!isEditing}
                    disabled={!isEditing}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex align-items-center gap-2">
                  <div className="text-start">
                    <div className="brand-dark-purple">Show email</div>
                    {isEditing ? (
                      <div className="bcs-subtitle">
                        If on, your email address appears on your public
                        profile.
                      </div>
                    ) : (
                      <div className="bcs-subtitle">
                        {privacyText(!!form.showEmail)}
                      </div>
                    )}
                  </div>

                  <input
                    className="form-check-input bcs-brand-check m-0"
                    type="checkbox"
                    name="showEmail"
                    checked={!!form.showEmail}
                    onChange={isEditing ? onToggle : undefined}
                    readOnly={!isEditing}
                    disabled={!isEditing}
                  />
                </div>
              </div>
            </div>

            <div>
              <label className="form-label bcs-subtitle m-0">Website</label>
              {isEditing ? (
                <div className="bcs-subtitle">
                  Optional, link to your practice website or booking page.
                </div>
              ) : null}

              {isEditing ? (
                <>
                  <div className="d-flex align-items-center gap-2 mt-2 mb-2">
                    <div className="text-start">
                      <div className="brand-dark-purple">
                        Hide my website link
                      </div>
                      <div className="bcs-subtitle">
                        {form.noWebsite
                          ? "Your website will not show publicly."
                          : "Your website will show publicly."}
                      </div>
                    </div>

                    <input
                      className="form-check-input bcs-brand-check m-0"
                      type="checkbox"
                      name="noWebsite"
                      checked={!!form.noWebsite}
                      onChange={onToggle}
                    />
                  </div>

                  <input
                    className="form-control bcs-brand-input"
                    name="websiteUrl"
                    type="text"
                    value={form.websiteUrl}
                    onChange={onText}
                    disabled={!!form.noWebsite}
                    placeholder="eg https://yourwebsite.com"
                  />
                </>
              ) : (
                <>
                  <div className="d-flex align-items-center gap-2 mt-2 mb-2">
                    <div className="text-start">
                      <div className="brand-dark-purple">
                        Hide my website link
                      </div>
                      <div className="bcs-subtitle">
                        {form.noWebsite
                          ? "Your website will not show publicly."
                          : "Your website will show publicly."}
                      </div>
                    </div>

                    <input
                      className="form-check-input bcs-brand-check m-0"
                      type="checkbox"
                      checked={!!form.noWebsite}
                      readOnly
                      disabled
                    />
                  </div>

                  <input
                    className="form-control bcs-brand-input"
                    type="text"
                    value={
                      form.noWebsite || display(form.websiteUrl) === "—"
                        ? ""
                        : form.websiteUrl
                    }
                    readOnly
                    disabled
                  />
                </>
              )}
            </div>
          </div>

          <div className="mb-4">
            <div className="text-start">
              <div className="brand-dark-purple mb-2">Qualifications</div>
            </div>
            {isEditing ? (
              <div className="bcs-subtitle mb-2">
                Add your key qualifications so clients can quickly understand
                your training.
              </div>
            ) : null}

            {!isEditing ? (
              qualifcations?.length ? (
                <div className="d-flex flex-wrap gap-2">
                  {qualifcations.map((q) => (
                    <span
                      key={q.id}
                      className="badge rounded-pill text-bg-light border"
                    >
                      {q.name}
                    </span>
                  ))}
                </div>
              ) : (
                <div className="bcs-subtitle">—</div>
              )
            ) : (
              <QualificationsCrud
                user={user}
                qualifications={qualifcations}
                setQualifications={setQualifications}
              />
            )}
          </div>

          <div className="mb-4">
            <div className="text-start">
              <div className="brand-dark-purple mb-2">Sessions and format</div>
            </div>
            {isEditing ? (
              <div className="bcs-subtitle mb-2">
                Help people understand how sessions work and what they cost.
              </div>
            ) : null}

            <div className="row g-3 mb-3">
              <div className="col-12">
                <div className="d-flex align-items-center gap-2">
                  <div className="text-start">
                    <div className="brand-dark-purple">Online sessions</div>
                    {isEditing ? (
                      <div className="bcs-subtitle">
                        Turn this on if you offer sessions by video call.
                      </div>
                    ) : (
                      <div className="bcs-subtitle">
                        {form.online ? "Offered" : "Not offered"}
                      </div>
                    )}
                  </div>

                  <input
                    className="form-check-input bcs-brand-check m-0"
                    type="checkbox"
                    name="online"
                    checked={!!form.online}
                    onChange={isEditing ? onToggle : undefined}
                    readOnly={!isEditing}
                    disabled={!isEditing}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex align-items-center gap-2">
                  <div className="text-start">
                    <div className="brand-dark-purple">Phone sessions</div>
                    {isEditing ? (
                      <div className="bcs-subtitle">
                        Turn this on if you offer sessions by phone call.
                      </div>
                    ) : (
                      <div className="bcs-subtitle">
                        {form.phone ? "Offered" : "Not offered"}
                      </div>
                    )}
                  </div>

                  <input
                    className="form-check-input bcs-brand-check m-0"
                    type="checkbox"
                    name="phone"
                    checked={!!form.phone}
                    onChange={isEditing ? onToggle : undefined}
                    readOnly={!isEditing}
                    disabled={!isEditing}
                  />
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex align-items-center gap-2">
                  <div className="text-start">
                    <div className="brand-dark-purple">In-person sessions</div>
                    {isEditing ? (
                      <div className="bcs-subtitle">
                        Turn this on if you offer face-to-face appointments.
                      </div>
                    ) : (
                      <div className="bcs-subtitle">
                        {form.offersInPerson ? "Offered" : "Not offered"}
                      </div>
                    )}
                  </div>

                  <input
                    className="form-check-input bcs-brand-check m-0"
                    type="checkbox"
                    name="offersInPerson"
                    checked={!!form.offersInPerson}
                    onChange={isEditing ? onToggle : undefined}
                    readOnly={!isEditing}
                    disabled={!isEditing}
                  />
                </div>
              </div>
            </div>

        {form.offersInPerson ? (
  <div className="mb-3">
    <label className="form-label bcs-subtitle m-0">
      Town / city
    </label>

    {isEditing ? (
      <>
        <div className="bcs-subtitle">
          Enter the town or city you want shown on your public profile.
        </div>

        <input
          className="form-control bcs-brand-input"
          name="townCity"
          type="text"
          value={form.townCity}
          onChange={onText}
          placeholder="eg Manchester"
        />
      </>
    ) : (
      <input
        className="form-control bcs-brand-input mt-2"
        type="text"
        value={form.townCity || ""}
        readOnly
        disabled
      />
    )}

    <label className="form-label bcs-subtitle m-0 mt-3">
      Practice postcode
    </label>

    {isEditing ? (
      <>
     <div className="bcs-subtitle">
  Enter your full postcode to help clients find therapists near
  them. Your postcode is never shown publicly and is only used
  for location-based search and distance matching.
</div>

        <input
          className="form-control bcs-brand-input"
          name="postcode"
          type="text"
          value={form.postcode}
          onChange={onText}
          placeholder="eg SW1A 1AA"
        />

        {saveError ? (
          <div className="text-danger small mt-2">{saveError}</div>
        ) : null}
      </>
    ) : (
      <>
       <div className="bcs-subtitle">
  Your postcode is not shown publicly and is only used for location-based search.
</div>

        <input
          className="form-control bcs-brand-input mt-2"
          type="text"
          value={form.postcode || ""}
          readOnly
          disabled
        />
      </>
    )}
  </div>
) : null}

            <div className="mb-3">
              <label className="form-label bcs-subtitle m-0">Platforms</label>
              {isEditing ? (
                <div className="bcs-subtitle">
                  List the tools you use for online sessions.
                </div>
              ) : null}
              {isEditing ? (
                <input
                  className="form-control bcs-brand-input"
                  name="platforms"
                  type="text"
                  value={form.platforms}
                  onChange={onText}
                  placeholder="eg Zoom, Microsoft Teams, Google Meet, WhatsApp"
                  disabled={!form.online}
                />
              ) : (
                <input
                  className="form-control bcs-brand-input mt-2"
                  type="text"
                  value={
                    form.online
                      ? display(form.platforms) === "—"
                        ? ""
                        : form.platforms
                      : ""
                  }
                  readOnly
                  disabled
                />
              )}
            </div>

            <div className="row g-3">
              <div className="col-12">
                <label className="form-label bcs-subtitle m-0">
                  Session length minutes
                </label>
                {isEditing ? (
                  <div className="bcs-subtitle">
                    Typical length for one session.
                  </div>
                ) : null}
                {isEditing ? (
                  <input
                    className="form-control bcs-brand-input"
                    name="sessionLength"
                    type="number"
                    value={form.sessionLength}
                    onChange={onText}
                    placeholder="eg 50"
                  />
                ) : (
                  <input
                    className="form-control bcs-brand-input mt-2"
                    type="number"
                    value={
                      display(form.sessionLength) === "—"
                        ? ""
                        : form.sessionLength
                    }
                    readOnly
                    disabled
                  />
                )}
              </div>

              <div className="col-12">
                <label className="form-label bcs-subtitle m-0">
                  Price per session
                </label>
                {isEditing ? (
                  <div className="bcs-subtitle">
                    Your standard price for a single session.
                  </div>
                ) : null}
                {isEditing ? (
                  <div className="input-group">
                    <span className="input-group-text">{currencySymbol}</span>
                    <input
                      className="form-control bcs-brand-input"
                      name="pricePerSession"
                      type="number"
                      value={form.pricePerSession}
                      onChange={onText}
                      placeholder="eg 60"
                    />
                  </div>
                ) : (
                  <div className="input-group mt-2">
                    <span className="input-group-text">{currencySymbol}</span>
                    <input
                      className="form-control bcs-brand-input"
                      type="number"
                      value={
                        display(form.pricePerSession) === "—"
                          ? ""
                          : form.pricePerSession
                      }
                      readOnly
                      disabled
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="mb-4">
            <div className="text-start">
              <div className="brand-dark-purple mb-2">Focus and experience</div>
            </div>
            {isEditing ? (
              <div className="bcs-subtitle mb-2">
                Choose the labels that best describe your experience. You can
                change these anytime.
              </div>
            ) : null}
            {!isEditing ? (
              chipList(focusItems)
            ) : (
              <div className="d-flex flex-wrap gap-2">
                {focusItems.map((it) => (
                  <label
                    key={it.name}
                    className={`btn btn-sm ${form[it.name] ? "brand-purple-inline" : "brand-purple-outline"}`}
                    style={undefined}
                  >
                    <input
                      type="checkbox"
                      name={it.name}
                      checked={!!form[it.name]}
                      onChange={onToggle}
                      className="d-none"
                    />
                    {it.label}
                  </label>
                ))}
              </div>
            )}
          </div>

          <div className="mb-4">
            <div className="text-start">
              <div className="brand-dark-purple mb-2">Works with</div>
            </div>
            {isEditing ? (
              <div className="bcs-subtitle mb-2">
                This helps clients find the right match for their age group.
              </div>
            ) : null}
            {!isEditing ? (
              chipList(worksWithItems)
            ) : (
              <div className="d-flex flex-wrap gap-2">
                {worksWithItems.map((it) => (
                  <label
                    key={it.name}
                    className={`btn btn-sm ${form[it.name] ? "brand-purple-inline" : "brand-purple-outline"}`}
                    style={undefined}
                  >
                    <input
                      type="checkbox"
                      name={it.name}
                      checked={!!form[it.name]}
                      onChange={onToggle}
                      className="d-none"
                    />
                    {it.label}
                  </label>
                ))}
              </div>
            )}
          </div>

          <div className="mb-4">
            <div className="d-flex align-items-center gap-3 mb-2">
              <div className="text-start">
                <div className="brand-dark-purple">Therapy types</div>
                {isEditing ? (
                  <div className="bcs-subtitle">
                    Pick the approaches you use most often. You can search to
                    find items quickly.
                  </div>
                ) : (
                  <div className="bcs-subtitle">
                    {selectedText(therapyItems)}
                  </div>
                )}
              </div>
            </div>

            {!isEditing
              ? chipList(therapyItems)
              : chipEditor(
                  therapyItems,
                  therapySearch,
                  setTherapySearch,
                  "Select only what you actively offer so clients get accurate results.",
                )}
          </div>

          <div className="mb-4">
            <div className="d-flex align-items-center gap-3 mb-2">
              <div className="text-start">
                <div className="brand-dark-purple">Areas of support</div>
                {isEditing ? (
                  <div className="bcs-subtitle">
                    Choose the topics you feel confident supporting. You can
                    search to find items quickly.
                  </div>
                ) : (
                  <div className="bcs-subtitle">
                    {selectedText(supportItems)}
                  </div>
                )}
              </div>
            </div>

            {!isEditing
              ? chipList(supportItems)
              : chipEditor(
                  supportItems,
                  supportSearch,
                  setSupportSearch,
                  "Choose the areas you would like clients to contact you about.",
                )}
          </div>

          {isEditing ? (
            <div className="d-flex justify-content-end gap-2">
              <button
                type="button"
                className="lp-btn lp-btn-ghost"
                onClick={handleCancel}
                disabled={isLoading}
              >
                Discard changes
              </button>
              <button
                type="submit"
                className="lp-btn brand-purple-inline"
                disabled={isLoading || !isDirty}
              >
                {isLoading ? "Saving..." : "Save changes"}
              </button>
            </div>
          ) : null}
        </form>
      </div>
    </div>
  );
}
